// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Paper,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   IconButton,
//   Tooltip,
//   Typography,
//   CircularProgress,
//   Alert,
//   Snackbar,
//   Pagination,
//   Button,
//   Stack,
// } from "@mui/material";
// import {
//   RefreshOutlined,
//   EditOutlined,
//   DeleteOutlineRounded,
//   FilterAltOutlined,
//   FilterAltOffOutlined,
//   ChatBubbleOutlineRounded,
//   DescriptionOutlined,
//   PictureAsPdfOutlined,
// } from "@mui/icons-material";
// import { keyframes } from "@mui/system";
// import { useNavigate } from "react-router-dom";
// import { adminService } from "../services/adminService";
// import SupportFilterDialog from "../components/SupportFilterDialog";
// import SupportNotesDialog from "../components/SupportNotesDialog";
// import SupportEditDialog from "../components/SupportEditDialog";
// import { textPrimary, textSecondary } from "../../../constants/consts";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const fadeInUp = keyframes`
//   from { opacity: 0; transform: translateY(14px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;

// const PAGE_SIZE = 13;

// const STATUS_CHIP = {
//   Gönderildi: { fg: "#B45309", bg: "#FEF3C7", border: "#FCD34D" },
//   işlemde: { fg: "#1D4ED8", bg: "#DBEAFE", border: "#93C5FD" },
//   Beklemede: { fg: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5" },
//   Tamamlandı: { fg: "#15803D", bg: "#DCFCE7", border: "#86EFAC" },
//   cancel: { fg: "#475569", bg: "#F1F5F9", border: "#CBD5E1" },
// };

// const CONTRACT_CHIP = {
//   yes: { fg: "#15803D", bg: "#DCFCE7", border: "#86EFAC", label: "Var" },
//   no: { fg: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5", label: "Yok" },
//   new: { fg: "#1D4ED8", bg: "#DBEAFE", border: "#93C5FD", label: "Yeni" },
// };

// // ─────────── Satır arka plan rengi (duruma göre) ───────────
// const STATUS_ROW_BG = {
//   Gönderildi: "rgba(245,158,11,0.08)",
//   işlemde: "rgba(59,130,246,0.08)",
//   Beklemede: "rgba(239,68,68,0.07)",
//   Tamamlandı: "rgba(34,197,94,0.08)",
//   cancel: "rgba(148,163,184,0.10)",
// };

// const rowBgOf = (status) => STATUS_ROW_BG[status] || "#fff";

// /* ─────────── Tarih yardımcıları ─────────── */

// // Timezone bilgisi yoksa UTC kabul ederek Date objesi döner
// function parseDate(iso) {
//   if (!iso) return null;
//   try {
//     let str = String(iso).trim();

//     // Zaten timezone bilgisi var mı? (Z, +03:00, GMT, UTC, +0300)
//     const hasTz = /Z$|[+-]\d{2}:?\d{2}$|\b(GMT|UTC)\b/i.test(str);

//     // Timezone yoksa UTC kabul et
//     if (!hasTz) {
//       str = str.replace(" ", "T") + "Z";
//     }

//     const d = new Date(str);
//     return isNaN(d.getTime()) ? null : d;
//   } catch {
//     return null;
//   }
// }
// // GMT'siz, gg/aa/yyyy ss:dd formatı
// function formatDate(iso) {
//   const d = parseDate(iso);
//   if (!d) return iso || "-";
//   const p = (n) => String(n).padStart(2, "0");
//   return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
// }

// export default function AdminSupports() {
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [error, setError] = useState("");
//   const [page, setPage] = useState(1);

//   const [sunucuKoduList, setSunucuKoduList] = useState([]);
//   const [personelList, setPersonelList] = useState([]);

//   const [filters, setFilters] = useState({
//     sunucuKodu: "",
//     personel: "",
//     durum: "",
//     contract: "",
//     startDate: "",
//     endDate: "",
//   });
//   const [filterOpen, setFilterOpen] = useState(false);

//   const [editDialog, setEditDialog] = useState({ open: false, support: null });
//   const [notesDialog, setNotesDialog] = useState({
//     open: false,
//     title: "",
//     note: "",
//     summary: "",
//   });

//   const [snack, setSnack] = useState({
//     open: false,
//     msg: "",
//     severity: "info",
//   });

//   /* ─────────── Veri yükleme ─────────── */
//   const loadData = async (silent = false) => {
//     if (silent) setRefreshing(true);
//     else setLoading(true);
//     setError("");
//     try {
//       const data = await adminService.getSupports();
//       const mapped = data.map((s) => ({
//         id: String(s.id),
//         title: s.title ?? "-",
//         status: s.status ?? "",
//         sunucuKodu: s.sunucu_kodu ?? "",
//         supporter: s.supporter ?? "",
//         username: s.username ?? "-",
//         userId: s.user_id ?? null,
//         contract: s.contract ?? "",
//         note: s.note ?? "",
//         summary: s.summary ?? "",
//         createdAt: s.created_at,
//         startAt: s.start_at,
//         endAt: s.end_at,
//       }));
//       setRows(mapped);
//       setPage(1);
//     } catch (e) {
//       console.error(e);
//       setError("Destek talepleri yüklenemedi.");
//     } finally {
//       if (silent) setRefreshing(false);
//       else setLoading(false);
//     }
//   };

//   const loadFilterData = async () => {
//     try {
//       const [companies, supporters] = await Promise.all([
//         adminService.getCompanies(),
//         adminService.getUsersByType({ type: "destek", sunucuKodu: "" }),
//       ]);
//       setSunucuKoduList(companies.map((c) => c.sunucu_kodu).filter(Boolean));
//       const names = supporters.map((u) => u.username).filter(Boolean);
//       // Havuz her zaman seçenek
//       setPersonelList(["Havuz", ...names]);
//     } catch (e) {
//       console.warn("Filtre verileri yüklenemedi:", e?.message);
//     }
//   };

//   useEffect(() => {
//     loadData();
//     loadFilterData();
//     // eslint-disable-next-line
//   }, []);

//   /* ─────────── Filtreleme ─────────── */
//   const filtered = useMemo(() => {
//     return rows.filter((r) => {
//       if (filters.sunucuKodu && r.sunucuKodu !== filters.sunucuKodu)
//         return false;
//       if (filters.personel && r.supporter !== filters.personel) return false;
//       if (filters.durum && r.status !== filters.durum) return false;
//       if (filters.contract && r.contract !== filters.contract) return false;

//       // ✅ Tarih filtresi de aynı parseDate ile yapılıyor (timezone tutarlı)
//       if (filters.startDate) {
//         const start = new Date(filters.startDate);
//         const created = parseDate(r.createdAt);
//         if (!isNaN(start) && created && created < start) return false;
//       }
//       if (filters.endDate) {
//         const end = new Date(filters.endDate);
//         end.setHours(23, 59, 59, 999);
//         const created = parseDate(r.createdAt);
//         if (!isNaN(end) && created && created > end) return false;
//       }
//       return true;
//     });
//   }, [rows, filters]);

//   const hasActiveFilter = Object.values(filters).some(
//     (v) => v && String(v).trim() !== "",
//   );

//   /* ─────────── Sayfalama ─────────── */
//   const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
//   const safePage = Math.min(page, totalPages);
//   const pageRows = filtered.slice(
//     (safePage - 1) * PAGE_SIZE,
//     safePage * PAGE_SIZE,
//   );

//   /* ─────────── Silme ─────────── */
//   const handleDelete = async (row) => {
//     if (!window.confirm(`"${row.title}" silinsin mi?`)) return;
//     try {
//       await adminService.deleteSupport(row.id);
//       setSnack({ open: true, msg: "Talep silindi.", severity: "success" });
//       await loadData(true);
//     } catch (e) {
//       console.error(e);
//       setSnack({
//         open: true,
//         msg: "Silme başarısız.",
//         severity: "error",
//       });
//     }
//   };

//   /* ─────────── PDF Export ─────────── */
//   // Türkçe karakterleri ASCII'ye çevirir — jsPDF default fontu için
//   const trToAscii = (s = "") =>
//     String(s)
//       .replace(/ş/g, "s")
//       .replace(/Ş/g, "S")
//       .replace(/ğ/g, "g")
//       .replace(/Ğ/g, "G")
//       .replace(/ı/g, "i")
//       .replace(/İ/g, "I")
//       .replace(/ç/g, "c")
//       .replace(/Ç/g, "C")
//       .replace(/ö/g, "o")
//       .replace(/Ö/g, "O")
//       .replace(/ü/g, "u")
//       .replace(/Ü/g, "U");

//   const handlePdf = () => {
//     try {
//       const doc = new jsPDF({ orientation: "landscape" });
//       doc.setFontSize(16);
//       doc.text("Destek Kayit Listesi", 14, 16);
//       doc.setFontSize(9);
//       // ✅ GMT'siz tarih
//       doc.text(`Tarih: ${formatDate(new Date().toISOString())}`, 14, 22);

//       const body = filtered.map((r) => [
//         trToAscii(r.title),
//         trToAscii(r.sunucuKodu),
//         trToAscii(r.username),
//         trToAscii(r.supporter || "-"),
//         trToAscii(r.status),
//         trToAscii(formatDate(r.createdAt)),
//       ]);

//       autoTable(doc, {
//         startY: 28,
//         head: [["Konu", "Sunucu", "Kullanici", "Personel", "Durum", "Tarih"]],
//         body,
//         styles: { fontSize: 8 },
//         headStyles: { fillColor: [4, 87, 129] },
//       });

//       // ─── Yeni sekmede aç ───
//       const blobUrl = doc.output("bloburl");
//       const newTab = window.open(blobUrl, "_blank");

//       // Popup engelleyici kontrolü
//       if (!newTab) {
//         // Popup engellendiyse → indir (fallback)
//         doc.save(`destek-talepleri-${Date.now()}.pdf`);
//         setSnack({
//           open: true,
//           msg: "Popup engellendi, PDF indirildi.",
//           severity: "info",
//         });
//       }
//     } catch (e) {
//       console.error(e);
//       setSnack({
//         open: true,
//         msg: "PDF oluşturulamadı.",
//         severity: "error",
//       });
//     }
//   };

//   /* ─────────── Render ─────────── */
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//         minHeight: 0,
//         gap: 1.5,
//       }}
//     >
//       {/* Başlık */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//           flexShrink: 0,
//           flexWrap: "wrap",
//           animation: `${fadeInUp} 0.4s ease-out both`,
//         }}
//       >
//         <Typography
//           variant="h6"
//           fontWeight={800}
//           color="#fff"
//           sx={{ fontSize: 18 }}
//         >
//           Destek Talepleri
//         </Typography>
//         <Box
//           sx={{
//             px: 1.25,
//             py: 0.4,
//             borderRadius: 5,
//             backgroundColor: "rgba(255,255,255,0.14)",
//             color: "#fff",
//             fontWeight: 700,
//             fontSize: 12,
//             border: "1px solid rgba(255,255,255,0.18)",
//           }}
//         >
//           {filtered.length} kayıt
//         </Box>

//         <Stack direction="row" spacing={0.75} sx={{ ml: "auto" }}>
//           <Button
//             size="small"
//             variant="contained"
//             startIcon={<FilterAltOutlined />}
//             onClick={() => setFilterOpen(true)}
//             sx={{
//               textTransform: "none",
//               borderRadius: 2,
//               backgroundColor: "rgba(255,255,255,0.14)",
//               color: "#fff",
//               border: "1px solid rgba(255,255,255,0.20)",
//               fontWeight: 700,
//               "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
//             }}
//           >
//             Filtre
//           </Button>
//           {hasActiveFilter && (
//             <Tooltip title="Filtreyi temizle">
//               <span>
//                 <IconButton
//                   size="small"
//                   onClick={() =>
//                     setFilters({
//                       sunucuKodu: "",
//                       personel: "",
//                       durum: "",
//                       contract: "",
//                       startDate: "",
//                       endDate: "",
//                     })
//                   }
//                   sx={{
//                     color: "#fff",
//                     backgroundColor: "rgba(255,255,255,0.14)",
//                     border: "1px solid rgba(255,255,255,0.20)",
//                     "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
//                   }}
//                 >
//                   <FilterAltOffOutlined sx={{ fontSize: 18 }} />
//                 </IconButton>
//               </span>
//             </Tooltip>
//           )}
//           <Button
//             size="small"
//             variant="contained"
//             startIcon={<PictureAsPdfOutlined />}
//             onClick={handlePdf}
//             sx={{
//               textTransform: "none",
//               borderRadius: 2,
//               backgroundColor: "rgba(255,255,255,0.14)",
//               color: "#fff",
//               border: "1px solid rgba(255,255,255,0.20)",
//               fontWeight: 700,
//               "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
//             }}
//           >
//             PDF
//           </Button>
//           <Tooltip title="Yenile">
//             <span>
//               <IconButton
//                 size="small"
//                 onClick={() => loadData(true)}
//                 disabled={loading || refreshing}
//                 sx={{
//                   color: "#fff",
//                   backgroundColor: "rgba(255,255,255,0.12)",
//                   border: "1px solid rgba(255,255,255,0.18)",
//                   "&:hover": { backgroundColor: "rgba(255,255,255,0.22)" },
//                 }}
//               >
//                 <RefreshOutlined
//                   sx={{
//                     fontSize: 18,
//                     animation:
//                       loading || refreshing
//                         ? "spin 1.2s linear infinite"
//                         : "none",
//                     "@keyframes spin": { to: { transform: "rotate(360deg)" } },
//                   }}
//                 />
//               </IconButton>
//             </span>
//           </Tooltip>
//         </Stack>
//       </Box>

//       {/* Aktif filtre etiketleri */}
//       {hasActiveFilter && (
//         <Stack
//           direction="row"
//           spacing={0.75}
//           sx={{ flexWrap: "wrap", gap: 0.75 }}
//         >
//           {filters.sunucuKodu && (
//             <FilterChip label={`Sunucu: ${filters.sunucuKodu}`} />
//           )}
//           {filters.personel && (
//             <FilterChip label={`Personel: ${filters.personel}`} />
//           )}
//           {filters.durum && <FilterChip label={`Durum: ${filters.durum}`} />}
//           {filters.contract && (
//             <FilterChip
//               label={
//                 filters.contract === "yes"
//                   ? "Sözleşmeli"
//                   : filters.contract === "no"
//                     ? "Sözleşmeli Değil"
//                     : "Yeni"
//               }
//             />
//           )}
//           {filters.startDate && (
//             <FilterChip label={`Başlangıç: ${filters.startDate}`} />
//           )}
//           {filters.endDate && (
//             <FilterChip label={`Bitiş: ${filters.endDate}`} />
//           )}
//         </Stack>
//       )}

//       {error && (
//         <Alert severity="error" sx={{ borderRadius: 2 }}>
//           {error}
//         </Alert>
//       )}

//       {loading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//           <CircularProgress sx={{ color: "#fff" }} />
//         </Box>
//       ) : (
//         <>
//           <Paper
//             elevation={0}
//             sx={{
//               flex: 1,
//               minHeight: 0,
//               overflow: "hidden",
//               borderRadius: 2.5,
//               display: "flex",
//               flexDirection: "column",
//               backgroundColor: "rgba(255,255,255,0.98)",
//               boxShadow: "0 12px 32px rgba(0,0,0,0.20)",
//               border: "1px solid rgba(255,255,255,0.30)",
//               animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
//             }}
//           >
//             <Box
//               sx={{
//                 flex: 1,
//                 minHeight: 0,
//                 overflowY: "auto",
//                 "&::-webkit-scrollbar": { width: 6, height: 6 },
//                 "&::-webkit-scrollbar-thumb": {
//                   backgroundColor: "rgba(15,50,65,0.20)",
//                   borderRadius: 3,
//                 },
//               }}
//             >
//               <Table stickyHeader size="small">
//                 <TableHead>
//                   <TableRow
//                     sx={{
//                       "& th": {
//                         background:
//                           "linear-gradient(180deg, #F1F5F9 0%, #E2E8F0 100%)",
//                         color: "#334155",
//                         fontWeight: 800,
//                         fontSize: 10.5,
//                         textTransform: "uppercase",
//                         letterSpacing: "0.04em",
//                         py: 1,
//                         px: 1.5,
//                         borderBottom: "1px solid #CBD5E1",
//                         whiteSpace: "nowrap",
//                       },
//                     }}
//                   >
//                     <TableCell>Konu</TableCell>
//                     <TableCell>Sunucu</TableCell>
//                     <TableCell>Kullanıcı</TableCell>
//                     <TableCell>Personel</TableCell>
//                     <TableCell>Durum</TableCell>
//                     <TableCell>Sözleşme</TableCell>
//                     <TableCell>Tarih</TableCell>
//                     <TableCell align="right">İşlem</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {pageRows.length === 0 ? (
//                     <TableRow>
//                       <TableCell
//                         colSpan={8}
//                         sx={{
//                           textAlign: "center",
//                           py: 6,
//                           color: textSecondary,
//                           fontSize: 13,
//                         }}
//                       >
//                         Kayıt bulunamadı
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     pageRows.map((r) => (
//                       <TableRow
//                         key={r.id}
//                         sx={{
//                           backgroundColor: rowBgOf(r.status),
//                           "&:hover": {
//                             backgroundColor: "rgba(4,87,129,0.12)",
//                           },
//                           transition: "background-color 0.2s ease",
//                           "& td": {
//                             py: 0.75,
//                             px: 1.5,
//                             fontSize: 12.5,
//                             color: "#334155",
//                             borderBottom: "1px solid #F1F5F9",
//                           },
//                         }}
//                       >
//                         <TableCell
//                           sx={{
//                             fontWeight: 700,
//                             color: textPrimary,
//                             maxWidth: 240,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                           title={r.title}
//                         >
//                           {r.title}
//                         </TableCell>
//                         <TableCell>{r.sunucuKodu}</TableCell>
//                         <TableCell
//                           sx={{
//                             maxWidth: 140,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {r.username}
//                         </TableCell>
//                         <TableCell>{r.supporter || "Havuz"}</TableCell>
//                         <TableCell>
//                           <StatusChip status={r.status} />
//                         </TableCell>
//                         <TableCell>
//                           <ContractChip contract={r.contract} />
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             whiteSpace: "nowrap",
//                             color: textSecondary,
//                             fontSize: 11.5,
//                           }}
//                         >
//                           {formatDate(r.createdAt)}
//                         </TableCell>
//                         <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
//                           <Tooltip title="Notlar">
//                             <IconButton
//                               size="small"
//                               onClick={() =>
//                                 setNotesDialog({
//                                   open: true,
//                                   title: r.title,
//                                   note: r.note,
//                                   summary: r.summary,
//                                 })
//                               }
//                               sx={{
//                                 color: "#6D28D9",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(109,40,217,0.10)",
//                                 },
//                               }}
//                             >
//                               <DescriptionOutlined sx={{ fontSize: 18 }} />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Sohbet">
//                             <IconButton
//                               size="small"
//                               onClick={() =>
//                                 navigate(`/support/${r.id}/messages`, {
//                                   state: {
//                                     title: r.title,
//                                     status: r.status,
//                                     sunucuKodu: r.sunucuKodu,
//                                   },
//                                 })
//                               }
//                               sx={{
//                                 color: "#15803D",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(21,128,61,0.10)",
//                                 },
//                               }}
//                             >
//                               <ChatBubbleOutlineRounded sx={{ fontSize: 18 }} />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Düzenle">
//                             <IconButton
//                               size="small"
//                               onClick={() =>
//                                 setEditDialog({ open: true, support: r })
//                               }
//                               sx={{
//                                 color: "#045781",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(4,87,129,0.10)",
//                                 },
//                               }}
//                             >
//                               <EditOutlined sx={{ fontSize: 18 }} />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Sil">
//                             <IconButton
//                               size="small"
//                               onClick={() => handleDelete(r)}
//                               sx={{
//                                 color: "#B91C1C",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(185,28,28,0.10)",
//                                 },
//                               }}
//                             >
//                               <DeleteOutlineRounded sx={{ fontSize: 18 }} />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </Box>
//           </Paper>

//           {filtered.length > 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 flexShrink: 0,
//                 px: 0.5,
//                 animation: `${fadeInUp} 0.4s ease-out 0.2s backwards`,
//               }}
//             >
//               <Typography
//                 sx={{
//                   color: "rgba(255,255,255,0.75)",
//                   fontSize: 11.5,
//                   fontWeight: 600,
//                 }}
//               >
//                 {Math.min((safePage - 1) * PAGE_SIZE + 1, filtered.length)}–
//                 {Math.min(safePage * PAGE_SIZE, filtered.length)} /{" "}
//                 {filtered.length} kayıt
//               </Typography>
//               <Pagination
//                 count={totalPages}
//                 page={safePage}
//                 onChange={(_, p) => setPage(p)}
//                 size="small"
//                 sx={{
//                   "& .MuiPaginationItem-root": {
//                     color: "#fff",
//                     "&.Mui-selected": {
//                       backgroundColor: "rgba(255,255,255,0.24)",
//                       fontWeight: 800,
//                     },
//                     "&:hover": { backgroundColor: "rgba(255,255,255,0.14)" },
//                   },
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       )}

//       {/* Dialoglar */}
//       <SupportFilterDialog
//         open={filterOpen}
//         onClose={() => setFilterOpen(false)}
//         onApply={(f) => setFilters(f)}
//         sunucuKoduList={sunucuKoduList}
//         personelList={personelList}
//       />

//       <SupportNotesDialog
//         open={notesDialog.open}
//         onClose={() =>
//           setNotesDialog({ open: false, title: "", note: "", summary: "" })
//         }
//         title={notesDialog.title}
//         note={notesDialog.note}
//         summary={notesDialog.summary}
//       />

//       <SupportEditDialog
//         open={editDialog.open}
//         support={editDialog.support}
//         onClose={() => setEditDialog({ open: false, support: null })}
//         onSaved={() => {
//           setSnack({
//             open: true,
//             msg: "Talep güncellendi.",
//             severity: "success",
//           });
//           loadData(true);
//         }}
//         sunucuKoduList={sunucuKoduList}
//         personelList={personelList}
//       />

//       <Snackbar
//         open={snack.open}
//         autoHideDuration={3000}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           severity={snack.severity}
//           onClose={() => setSnack((s) => ({ ...s, open: false }))}
//           sx={{ borderRadius: 2 }}
//         >
//           {snack.msg}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// /* ─────────── Yardımcı bileşenler ─────────── */
// function StatusChip({ status }) {
//   const t = STATUS_CHIP[status] || {
//     fg: "#475569",
//     bg: "#F1F5F9",
//     border: "#CBD5E1",
//   };
//   return (
//     <Box
//       component="span"
//       sx={{
//         display: "inline-block",
//         px: 1,
//         py: 0.25,
//         borderRadius: 5,
//         backgroundColor: t.bg,
//         color: t.fg,
//         border: `1px solid ${t.border}`,
//         fontWeight: 700,
//         fontSize: 10.5,
//         whiteSpace: "nowrap",
//       }}
//     >
//       {status || "-"}
//     </Box>
//   );
// }

// function ContractChip({ contract }) {
//   const t = CONTRACT_CHIP[contract] || {
//     fg: "#475569",
//     bg: "#F1F5F9",
//     border: "#CBD5E1",
//     label: contract || "-",
//   };
//   return (
//     <Box
//       component="span"
//       sx={{
//         display: "inline-block",
//         px: 0.9,
//         py: 0.2,
//         borderRadius: 1,
//         backgroundColor: t.bg,
//         color: t.fg,
//         border: `1px solid ${t.border}`,
//         fontWeight: 700,
//         fontSize: 10.5,
//       }}
//     >
//       {t.label}
//     </Box>
//   );
// }

// function FilterChip({ label }) {
//   return (
//     <Box
//       sx={{
//         px: 1.25,
//         py: 0.4,
//         borderRadius: 5,
//         backgroundColor: "rgba(255,255,255,0.14)",
//         color: "#fff",
//         fontWeight: 700,
//         fontSize: 11.5,
//         border: "1px solid rgba(255,255,255,0.20)",
//       }}
//     >
//       {label}
//     </Box>
//   );
// }
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  Typography,
  CircularProgress,
  Alert,
  Snackbar,
  Pagination,
  Button,
  Stack,
} from "@mui/material";
import {
  RefreshOutlined,
  EditOutlined,
  DeleteOutlineRounded,
  FilterAltOutlined,
  FilterAltOffOutlined,
  ChatBubbleOutlineRounded,
  DescriptionOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { adminService } from "../services/adminService";
import SupportFilterDialog from "../components/SupportFilterDialog";
import SupportNotesDialog from "../components/SupportNotesDialog";
import SupportEditDialog from "../components/SupportEditDialog";
import { textPrimary, textSecondary } from "../../../constants/consts";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const PAGE_SIZE = 13;

const STATUS_CHIP = {
  Gönderildi: { fg: "#B45309", bg: "#FEF3C7", border: "#FCD34D" },
  işlemde: { fg: "#1D4ED8", bg: "#DBEAFE", border: "#93C5FD" },
  Beklemede: { fg: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5" },
  Tamamlandı: { fg: "#15803D", bg: "#DCFCE7", border: "#86EFAC" },
  cancel: { fg: "#475569", bg: "#F1F5F9", border: "#CBD5E1" },
};

const CONTRACT_CHIP = {
  yes: { fg: "#15803D", bg: "#DCFCE7", border: "#86EFAC", label: "Var" },
  no: { fg: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5", label: "Yok" },
  new: { fg: "#1D4ED8", bg: "#DBEAFE", border: "#93C5FD", label: "Yeni" },
};

// ─────────── Satır arka plan rengi (duruma göre) ───────────
const STATUS_ROW_BG = {
  Gönderildi: "rgba(245,158,11,0.08)",
  işlemde: "rgba(59,130,246,0.08)",
  Beklemede: "rgba(239,68,68,0.07)",
  Tamamlandı: "rgba(34,197,94,0.08)",
  cancel: "rgba(148,163,184,0.10)",
};

const rowBgOf = (status) => STATUS_ROW_BG[status] || "#fff";

/* ─────────── Tarih yardımcıları ───────────
   Backend Europe/Istanbul saatini timezone belirtmeden yazıyor
   (örn. "2024-01-15 14:30:00"). Bu yüzden:
   - Timezone VARSA → normal Date parse (tarayıcı local'e çevirir)
   - Timezone YOKSA → manuel parse (local olarak kabul et, offset uygulama)
*/
/* ─────────── Tarih yardımcıları ───────────
   Backend Flask `jsonify` datetime alanlarını otomatik
   RFC 822 formatına çeviriyor:  "Mon, 15 Jan 2024 14:30:00 GMT"
   Buradaki "GMT" SAHTE — gerçek değer Europe/Istanbul saati.
   O yüzden GMT'i yok sayıp saati olduğu gibi (local) kabul ediyoruz.
*/
function parseDate(iso) {
  if (!iso) return null;
  try {
    const str = String(iso).trim();

    // 1) RFC 822: "Mon, 15 Jan 2024 14:30:00 GMT" (Flask'ın çıktısı)
    //    → GMT suffix'ini YOK SAY, saati olduğu gibi local kabul et
    const rfc = str.match(
      /^[A-Za-z]{3},\s+(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})\s+(\d{2}):(\d{2}):(\d{2})(?:\s+(?:GMT|UTC))?$/i,
    );
    if (rfc) {
      const [, da, monStr, y, h, mi, se] = rfc;
      const months = {
        jan: 0,
        feb: 1,
        mar: 2,
        apr: 3,
        may: 4,
        jun: 5,
        jul: 6,
        aug: 7,
        sep: 8,
        oct: 9,
        nov: 10,
        dec: 11,
      };
      const mo = months[monStr.toLowerCase()];
      if (mo === undefined) return null;
      return new Date(
        parseInt(y, 10),
        mo,
        parseInt(da, 10),
        parseInt(h, 10),
        parseInt(mi, 10),
        parseInt(se, 10),
      );
    }

    // 2) Basit format: "2024-01-15 14:30:00" veya "2024-01-15T14:30:00"
    //    TZ bilgisi YOKSA → local kabul et (backend İstanbul saati yazıyor)
    const hasTz = /Z$|[+-]\d{2}:?\d{2}$/.test(str);
    if (!hasTz) {
      const m = str.match(
        /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/,
      );
      if (m) {
        const [, y, mo, da, h, mi, se] = m;
        return new Date(
          parseInt(y, 10),
          parseInt(mo, 10) - 1,
          parseInt(da, 10),
          parseInt(h, 10),
          parseInt(mi, 10),
          parseInt(se || "0", 10),
        );
      }
    }

    // 3) Timezone'lı ISO: "2024-01-15T14:30:00Z" / "+03:00"
    //    → tarayıcıya bırak, doğru çevirir
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

function formatDate(iso) {
  const d = parseDate(iso);
  if (!d) return iso || "-";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export default function AdminSupports() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);

  const [sunucuKoduList, setSunucuKoduList] = useState([]);
  const [personelList, setPersonelList] = useState([]);

  const [filters, setFilters] = useState({
    sunucuKodu: "",
    personel: "",
    durum: "",
    contract: "",
    startDate: "",
    endDate: "",
  });
  const [filterOpen, setFilterOpen] = useState(false);

  const [editDialog, setEditDialog] = useState({ open: false, support: null });
  const [notesDialog, setNotesDialog] = useState({
    open: false,
    title: "",
    note: "",
    summary: "",
  });

  const [snack, setSnack] = useState({
    open: false,
    msg: "",
    severity: "info",
  });

  /* ─────────── Veri yükleme ─────────── */
  const loadData = async (silent = false) => {
    if (silent) setRefreshing(true);
    else setLoading(true);
    setError("");
    try {
      const data = await adminService.getSupports();
      const mapped = data.map((s) => ({
        id: String(s.id),
        title: s.title ?? "-",
        status: s.status ?? "",
        sunucuKodu: s.sunucu_kodu ?? "",
        supporter: s.supporter ?? "",
        username: s.username ?? "-",
        userId: s.user_id ?? null,
        contract: s.contract ?? "",
        note: s.note ?? "",
        summary: s.summary ?? "",
        createdAt: s.created_at,
        startAt: s.start_at,
        endAt: s.end_at,
      }));
      setRows(mapped);
      setPage(1);
    } catch (e) {
      console.error(e);
      setError("Destek talepleri yüklenemedi.");
    } finally {
      if (silent) setRefreshing(false);
      else setLoading(false);
    }
  };

  const loadFilterData = async () => {
    try {
      const [companies, supporters] = await Promise.all([
        adminService.getCompanies(),
        adminService.getUsersByType({ type: "destek", sunucuKodu: "" }),
      ]);
      setSunucuKoduList(companies.map((c) => c.sunucu_kodu).filter(Boolean));
      const names = supporters.map((u) => u.username).filter(Boolean);
      setPersonelList(["Havuz", ...names]);
    } catch (e) {
      console.warn("Filtre verileri yüklenemedi:", e?.message);
    }
  };

  useEffect(() => {
    loadData();
    loadFilterData();
    // eslint-disable-next-line
  }, []);

  /* ─────────── Filtreleme ─────────── */
  const filtered = useMemo(() => {
    return rows.filter((r) => {
      if (filters.sunucuKodu && r.sunucuKodu !== filters.sunucuKodu)
        return false;
      if (filters.personel && r.supporter !== filters.personel) return false;
      if (filters.durum && r.status !== filters.durum) return false;
      if (filters.contract && r.contract !== filters.contract) return false;

      if (filters.startDate) {
        const start = new Date(filters.startDate);
        const created = parseDate(r.createdAt);
        if (!isNaN(start) && created && created < start) return false;
      }
      if (filters.endDate) {
        const end = new Date(filters.endDate);
        end.setHours(23, 59, 59, 999);
        const created = parseDate(r.createdAt);
        if (!isNaN(end) && created && created > end) return false;
      }
      return true;
    });
  }, [rows, filters]);

  const hasActiveFilter = Object.values(filters).some(
    (v) => v && String(v).trim() !== "",
  );

  /* ─────────── Sayfalama ─────────── */
  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const pageRows = filtered.slice(
    (safePage - 1) * PAGE_SIZE,
    safePage * PAGE_SIZE,
  );

  /* ─────────── Silme ─────────── */
  const handleDelete = async (row) => {
    if (!window.confirm(`"${row.title}" silinsin mi?`)) return;
    try {
      await adminService.deleteSupport(row.id);
      setSnack({ open: true, msg: "Talep silindi.", severity: "success" });
      await loadData(true);
    } catch (e) {
      console.error(e);
      setSnack({
        open: true,
        msg: "Silme başarısız.",
        severity: "error",
      });
    }
  };

  /* ─────────── PDF Export ─────────── */
  const trToAscii = (s = "") =>
    String(s)
      .replace(/ş/g, "s")
      .replace(/Ş/g, "S")
      .replace(/ğ/g, "g")
      .replace(/Ğ/g, "G")
      .replace(/ı/g, "i")
      .replace(/İ/g, "I")
      .replace(/ç/g, "c")
      .replace(/Ç/g, "C")
      .replace(/ö/g, "o")
      .replace(/Ö/g, "O")
      .replace(/ü/g, "u")
      .replace(/Ü/g, "U");

  const handlePdf = () => {
    try {
      const doc = new jsPDF({ orientation: "landscape" });
      doc.setFontSize(16);
      doc.text("Destek Kayit Listesi", 14, 16);
      doc.setFontSize(9);
      doc.text(`Tarih: ${formatDate(new Date().toISOString())}`, 14, 22);

      const body = filtered.map((r) => [
        trToAscii(r.title),
        trToAscii(r.sunucuKodu),
        trToAscii(r.username),
        trToAscii(r.supporter || "-"),
        trToAscii(r.status),
        trToAscii(formatDate(r.createdAt)),
      ]);

      autoTable(doc, {
        startY: 28,
        head: [["Konu", "Sunucu", "Kullanici", "Personel", "Durum", "Tarih"]],
        body,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [4, 87, 129] },
      });

      const blobUrl = doc.output("bloburl");
      const newTab = window.open(blobUrl, "_blank");

      if (!newTab) {
        doc.save(`destek-talepleri-${Date.now()}.pdf`);
        setSnack({
          open: true,
          msg: "Popup engellendi, PDF indirildi.",
          severity: "info",
        });
      }
    } catch (e) {
      console.error(e);
      setSnack({
        open: true,
        msg: "PDF oluşturulamadı.",
        severity: "error",
      });
    }
  };

  /* ─────────── Render ─────────── */
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        gap: 1.5,
      }}
    >
      {/* Başlık */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
          flexWrap: "wrap",
          animation: `${fadeInUp} 0.4s ease-out both`,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={800}
          color="#fff"
          sx={{ fontSize: 18 }}
        >
          Destek Talepleri
        </Typography>
        <Box
          sx={{
            px: 1.25,
            py: 0.4,
            borderRadius: 5,
            backgroundColor: "rgba(255,255,255,0.14)",
            color: "#fff",
            fontWeight: 700,
            fontSize: 12,
            border: "1px solid rgba(255,255,255,0.18)",
          }}
        >
          {filtered.length} kayıt
        </Box>

        <Stack direction="row" spacing={0.75} sx={{ ml: "auto" }}>
          <Button
            size="small"
            variant="contained"
            startIcon={<FilterAltOutlined />}
            onClick={() => setFilterOpen(true)}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              backgroundColor: "rgba(255,255,255,0.14)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.20)",
              fontWeight: 700,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
            }}
          >
            Filtre
          </Button>
          {hasActiveFilter && (
            <Tooltip title="Filtreyi temizle">
              <span>
                <IconButton
                  size="small"
                  onClick={() =>
                    setFilters({
                      sunucuKodu: "",
                      personel: "",
                      durum: "",
                      contract: "",
                      startDate: "",
                      endDate: "",
                    })
                  }
                  sx={{
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.14)",
                    border: "1px solid rgba(255,255,255,0.20)",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
                  }}
                >
                  <FilterAltOffOutlined sx={{ fontSize: 18 }} />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <Button
            size="small"
            variant="contained"
            startIcon={<PictureAsPdfOutlined />}
            onClick={handlePdf}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              backgroundColor: "rgba(255,255,255,0.14)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.20)",
              fontWeight: 700,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
            }}
          >
            PDF
          </Button>
          <Tooltip title="Yenile">
            <span>
              <IconButton
                size="small"
                onClick={() => loadData(true)}
                disabled={loading || refreshing}
                sx={{
                  color: "#fff",
                  backgroundColor: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.18)",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.22)" },
                }}
              >
                <RefreshOutlined
                  sx={{
                    fontSize: 18,
                    animation:
                      loading || refreshing
                        ? "spin 1.2s linear infinite"
                        : "none",
                    "@keyframes spin": { to: { transform: "rotate(360deg)" } },
                  }}
                />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      </Box>

      {/* Aktif filtre etiketleri */}
      {hasActiveFilter && (
        <Stack
          direction="row"
          spacing={0.75}
          sx={{ flexWrap: "wrap", gap: 0.75 }}
        >
          {filters.sunucuKodu && (
            <FilterChip label={`Sunucu: ${filters.sunucuKodu}`} />
          )}
          {filters.personel && (
            <FilterChip label={`Personel: ${filters.personel}`} />
          )}
          {filters.durum && <FilterChip label={`Durum: ${filters.durum}`} />}
          {filters.contract && (
            <FilterChip
              label={
                filters.contract === "yes"
                  ? "Sözleşmeli"
                  : filters.contract === "no"
                    ? "Sözleşmeli Değil"
                    : "Yeni"
              }
            />
          )}
          {filters.startDate && (
            <FilterChip label={`Başlangıç: ${filters.startDate}`} />
          )}
          {filters.endDate && (
            <FilterChip label={`Bitiş: ${filters.endDate}`} />
          )}
        </Stack>
      )}

      {error && (
        <Alert severity="error" sx={{ borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress sx={{ color: "#fff" }} />
        </Box>
      ) : (
        <>
          <Paper
            elevation={0}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
              borderRadius: 2.5,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "rgba(255,255,255,0.98)",
              boxShadow: "0 12px 32px rgba(0,0,0,0.20)",
              border: "1px solid rgba(255,255,255,0.30)",
              animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
            }}
          >
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                "&::-webkit-scrollbar": { width: 6, height: 6 },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "rgba(15,50,65,0.20)",
                  borderRadius: 3,
                },
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        background:
                          "linear-gradient(180deg, #F1F5F9 0%, #E2E8F0 100%)",
                        color: "#334155",
                        fontWeight: 800,
                        fontSize: 10.5,
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                        py: 1,
                        px: 1.5,
                        borderBottom: "1px solid #CBD5E1",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableCell>Konu</TableCell>
                    <TableCell>Sunucu</TableCell>
                    <TableCell>Kullanıcı</TableCell>
                    <TableCell>Personel</TableCell>
                    <TableCell>Durum</TableCell>
                    <TableCell>Sözleşme</TableCell>
                    <TableCell>Tarih</TableCell>
                    <TableCell align="right">İşlem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pageRows.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        sx={{
                          textAlign: "center",
                          py: 6,
                          color: textSecondary,
                          fontSize: 13,
                        }}
                      >
                        Kayıt bulunamadı
                      </TableCell>
                    </TableRow>
                  ) : (
                    pageRows.map((r) => (
                      <TableRow
                        key={r.id}
                        sx={{
                          backgroundColor: rowBgOf(r.status),
                          "&:hover": {
                            backgroundColor: "rgba(4,87,129,0.12)",
                          },
                          transition: "background-color 0.2s ease",
                          "& td": {
                            py: 0.9,
                            px: 1.5,
                            fontSize: 12.5,
                            color: "#334155",
                            borderBottom: "1px solid #F1F5F9",
                            verticalAlign: "top",
                          },
                        }}
                      >
                        {/* ✅ Başlık: uzunsa alt satıra iner */}
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            color: textPrimary,
                            minWidth: 200,
                            maxWidth: 320,
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: 1.35,
                          }}
                        >
                          {r.title}
                        </TableCell>

                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          {r.sunucuKodu}
                        </TableCell>

                        <TableCell
                          sx={{
                            maxWidth: 140,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {r.username}
                        </TableCell>

                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          {r.supporter || "Havuz"}
                        </TableCell>

                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          <StatusChip status={r.status} />
                        </TableCell>

                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          <ContractChip contract={r.contract} />
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            color: textSecondary,
                            fontSize: 11.5,
                          }}
                        >
                          {formatDate(r.createdAt)}
                        </TableCell>

                        <TableCell
                          align="right"
                          sx={{ whiteSpace: "nowrap", pt: 0.5 }}
                        >
                          <Tooltip title="Notlar">
                            <IconButton
                              size="small"
                              onClick={() =>
                                setNotesDialog({
                                  open: true,
                                  title: r.title,
                                  note: r.note,
                                  summary: r.summary,
                                })
                              }
                              sx={{
                                color: "#6D28D9",
                                "&:hover": {
                                  backgroundColor: "rgba(109,40,217,0.10)",
                                },
                              }}
                            >
                              <DescriptionOutlined sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Sohbet">
                            <IconButton
                              size="small"
                              onClick={() =>
                                navigate(`/support/${r.id}/messages`, {
                                  state: {
                                    title: r.title,
                                    status: r.status,
                                    sunucuKodu: r.sunucuKodu,
                                  },
                                })
                              }
                              sx={{
                                color: "#15803D",
                                "&:hover": {
                                  backgroundColor: "rgba(21,128,61,0.10)",
                                },
                              }}
                            >
                              <ChatBubbleOutlineRounded sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Düzenle">
                            <IconButton
                              size="small"
                              onClick={() =>
                                setEditDialog({ open: true, support: r })
                              }
                              sx={{
                                color: "#045781",
                                "&:hover": {
                                  backgroundColor: "rgba(4,87,129,0.10)",
                                },
                              }}
                            >
                              <EditOutlined sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Sil">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(r)}
                              sx={{
                                color: "#B91C1C",
                                "&:hover": {
                                  backgroundColor: "rgba(185,28,28,0.10)",
                                },
                              }}
                            >
                              <DeleteOutlineRounded sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Paper>

          {filtered.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexShrink: 0,
                px: 0.5,
                animation: `${fadeInUp} 0.4s ease-out 0.2s backwards`,
              }}
            >
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 11.5,
                  fontWeight: 600,
                }}
              >
                {Math.min((safePage - 1) * PAGE_SIZE + 1, filtered.length)}–
                {Math.min(safePage * PAGE_SIZE, filtered.length)} /{" "}
                {filtered.length} kayıt
              </Typography>
              <Pagination
                count={totalPages}
                page={safePage}
                onChange={(_, p) => setPage(p)}
                size="small"
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: "#fff",
                    "&.Mui-selected": {
                      backgroundColor: "rgba(255,255,255,0.24)",
                      fontWeight: 800,
                    },
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.14)" },
                  },
                }}
              />
            </Box>
          )}
        </>
      )}

      {/* Dialoglar */}
      <SupportFilterDialog
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        onApply={(f) => setFilters(f)}
        sunucuKoduList={sunucuKoduList}
        personelList={personelList}
      />

      <SupportNotesDialog
        open={notesDialog.open}
        onClose={() =>
          setNotesDialog({ open: false, title: "", note: "", summary: "" })
        }
        title={notesDialog.title}
        note={notesDialog.note}
        summary={notesDialog.summary}
      />

      <SupportEditDialog
        open={editDialog.open}
        support={editDialog.support}
        onClose={() => setEditDialog({ open: false, support: null })}
        onSaved={() => {
          setSnack({
            open: true,
            msg: "Talep güncellendi.",
            severity: "success",
          });
          loadData(true);
        }}
        sunucuKoduList={sunucuKoduList}
        personelList={personelList}
      />

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snack.severity}
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          sx={{ borderRadius: 2 }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}

/* ─────────── Yardımcı bileşenler ─────────── */
function StatusChip({ status }) {
  const t = STATUS_CHIP[status] || {
    fg: "#475569",
    bg: "#F1F5F9",
    border: "#CBD5E1",
  };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 1,
        py: 0.25,
        borderRadius: 5,
        backgroundColor: t.bg,
        color: t.fg,
        border: `1px solid ${t.border}`,
        fontWeight: 700,
        fontSize: 10.5,
        whiteSpace: "nowrap",
      }}
    >
      {status || "-"}
    </Box>
  );
}

function ContractChip({ contract }) {
  const t = CONTRACT_CHIP[contract] || {
    fg: "#475569",
    bg: "#F1F5F9",
    border: "#CBD5E1",
    label: contract || "-",
  };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 0.9,
        py: 0.2,
        borderRadius: 1,
        backgroundColor: t.bg,
        color: t.fg,
        border: `1px solid ${t.border}`,
        fontWeight: 700,
        fontSize: 10.5,
      }}
    >
      {t.label}
    </Box>
  );
}

function FilterChip({ label }) {
  return (
    <Box
      sx={{
        px: 1.25,
        py: 0.4,
        borderRadius: 5,
        backgroundColor: "rgba(255,255,255,0.14)",
        color: "#fff",
        fontWeight: 700,
        fontSize: 11.5,
        border: "1px solid rgba(255,255,255,0.20)",
      }}
    >
      {label}
    </Box>
  );
}
